export default __webpack_public_path__ + "static/media/cerrar-modal.d44b8ade.svg";